import { computationOptions } from "#app/computationOptions";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import {
  computeQuoteRequestLinePrice,
  OptimizedMachineTimes,
  OptimizedMaterialCosts,
} from "shared";

export const NO_PRICE_PLACEHOLDER = "--";

export const getComputedQuoteRequestLinePrice = (
  line: QuoteRequestLineDto,
  optimizedMachineTimes: OptimizedMachineTimes,
  optimizedMaterialCosts: OptimizedMaterialCosts,
) => {
  if (!line.processSteps.length) {
    return null;
  }
  return computeQuoteRequestLinePrice(
    {
      quoteRequestLine: line,
      optimizedMachineTimes,
      optimizedMaterialCosts,
    },
    computationOptions,
  );
};
